import { useState } from 'react';
import './GatherDataCard.css';
import UserInfo from '../Form/UserInfo';
import CardHeader from './CardComponents/CardHeader/CardHeader';
import CardAccordion from './CardComponents/CardAccordion/CardAccordion';

function GatherDataCard(props:{
    changeState: () => void,
}){
    const [userDetails, setUserDetails] = useState<UserInfo>({
        age: undefined,
        sex: undefined,
        weight: undefined,
        height: undefined,
        activityLevel: undefined,
        pregnantOrBreastFeeding: undefined,
        pregnant: undefined,
        pregnancyTrimester: undefined,
        breastfeeding: undefined,
        breastfeedingAmount: undefined,
        breastfeedingTime: undefined,
        finalCalories: {
            overall: 0,
            maintain: 0,
            achieveHealthy: 0,
        },
        low: undefined,
        mid: undefined,
        high: undefined,
        bmi: undefined,
        bmiLevel: undefined
    })
    return(
        <div className='card df fdc aic jcfs'>
            <CardHeader title='GSPEN' button={props.changeState}/>
            <CardAccordion userDetails={userDetails} setUserDetails={setUserDetails}/>
        </div>
    )
}

export default GatherDataCard;